// export const baseUrl = "http://localhost:8080/api/v1/";
export const baseUrl = "https://kombuscoby-backend.herokuapp.com/api/v1/";
